// extracted by mini-css-extract-plugin
export default {"connectContainer":"style_connectContainer__ozlc2","sideContainer":"style_sideContainer__YGZ5D"};